import React from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import classes from './non-vector-image-upload-popup.scss';
import { ButtonGroup } from './components/button-group';
import { Title } from './components/title';
export const NonVectorImageUploadPopupComponent = ({
  open,
  onClose,
  view,
  file,
  isLimitedEdition,
  handleUploadLogo,
  handleContinueUploadLogo
}) => {
  const handleClickUploadNewFile = e => {
    if (!e.target.files) {
      return;
    }
    const file = e.target.files[0];
    handleUploadLogo(file, view);
  };
  const handleClickContinueUpload = () => {
    handleContinueUploadLogo(file, view);
  };
  const renderContent = () => /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.description
  }, "If possible, please upload a vector file (AI or EPS) instead. If you don\u2019t have one, we can convert your current file for you \u2013 but this may result in small changes. We will send you a virtual mock-up to approve after we perform the conversion."), /*#__PURE__*/React.createElement(ButtonGroup, {
    isLimitedEdition: isLimitedEdition,
    handleClickContinueUpload: handleClickContinueUpload,
    handleClickUploadNewFile: handleClickUploadNewFile
  }));
  return /*#__PURE__*/React.createElement(PopupDialog, {
    title: /*#__PURE__*/React.createElement(Title, null),
    dataPopup: "NonVectorImageUploadPopup",
    titleClasses: classes.header,
    titleHeader: classes.header,
    content: renderContent(),
    contentClass: classes.content,
    popupClassName: classes.popup,
    onClose: onClose,
    showCloseButton: true,
    closeClass: isLimitedEdition ? classes.orangeClose : '',
    open: open
  });
};